// ── Aisle configuration ──────────────────────────────────────────────────────
// Maps UI aisle rows to the `category` field values in product data.
// comingSoon: true = greyed-out "Coming soon" row, not tappable.
export const AISLES = [
  { id: 'fresh_fridge',  name: 'Fresh & Fridge',    icon: '🥛', categories: ['fresh_fridge', 'dairy'],                   comingSoon: false },
  { id: 'fruit_veg',     name: 'Fruit & Veg',        icon: '🥕', categories: ['produce', 'fruit_veg'],                    comingSoon: false },
  { id: 'bakery',        name: 'Bread & Bakery',      icon: '🍞', categories: ['bread_bakery', 'bakery'],                  comingSoon: false },
  { id: 'cupboard',      name: 'Tinned & Cupboard',   icon: '🥫', categories: ['tinned_cupboard', 'pantry'],               comingSoon: false },
  { id: 'snacks',        name: 'Snacks',               icon: '🍿', categories: ['snacks'],    comingSoon: true  },
  { id: 'drinks',        name: 'Drinks',               icon: '🥤', categories: ['drinks'],    comingSoon: true  },
  { id: 'meat',          name: 'Meat & Poultry',       icon: '🥩', categories: ['meat'],      comingSoon: true  },
  { id: 'frozen',        name: 'Frozen',               icon: '🧊', categories: ['frozen'],    comingSoon: true  },
  { id: 'household',     name: 'Household',            icon: '🧴', categories: ['household'], comingSoon: true  },
];

// ── Subcategory display config ────────────────────────────────────────────────
// Keys correspond to the `subcategory` field written to product documents.
// Add new entries here when you add subcategories to the CSV.
//
// comparisonMode declares the intended unit for browse comparison.
// The comparison engine uses unitType from retailer docs for calculation;
// comparisonMode is the human-readable contract so the rule is explicit.
//
//   unit_100g   — weight-sold: potatoes, cheese, butter, bread, flour, rice…
//   unit_100ml  — liquid-sold: milk, cream, oil, juice…
//   unit_each   — per-item: eggs, bananas, rolls…
//   pack_only   — no meaningful unit comparison (mixed multipacks, etc.)
//   (omitted)   — not yet in catalogue, no comparison declared
//
export const SUBCATEGORY_CONFIG = {
  // Fresh & Fridge
  cheese:      { name: 'Cheese',             icon: '🧀', comparisonMode: 'unit_100g'  },
  milk:        { name: 'Milk',               icon: '🥛', comparisonMode: 'unit_100ml' },
  eggs:        { name: 'Eggs',               icon: '🥚', comparisonMode: 'unit_each'  },
  butter:      { name: 'Butter',             icon: '🧈', comparisonMode: 'unit_100g'  },
  yogurt:      { name: 'Yogurt',             icon: '🫙', comparisonMode: 'unit_100g'  },
  cream:       { name: 'Cream',              icon: '🍦', comparisonMode: 'unit_100ml' },
  deli:        { name: 'Deli',               icon: '🥓' },
  meat_fresh:  { name: 'Fresh Meat',         icon: '🥩' },
  fish:        { name: 'Fish',               icon: '🐟' },
  juice_fresh:         { name: 'Fresh Juice',        icon: '🍊', comparisonMode: 'unit_100ml' },
  plant_based_drinks:  { name: 'Plant-Based Drinks', icon: '🌿', comparisonMode: 'unit_100ml' },
  // Fruit & Veg
  fruit:       { name: 'Fruit',              icon: '🍎' },
  fresh_fruit: { name: 'Fresh Fruit',        icon: '🍓' },
  banana:      { name: 'Bananas',            icon: '🍌', comparisonMode: 'unit_each'  },
  bananas:     { name: 'Bananas',            icon: '🍌', comparisonMode: 'unit_each'  },
  citrus:      { name: 'Citrus',             icon: '🍊' },
  berries:     { name: 'Berries',            icon: '🍓' },
  vegetables:  { name: 'Vegetables',         icon: '🥦', comparisonMode: 'unit_100g'  },
  root_veg:    { name: 'Root Veg',           icon: '🥕', comparisonMode: 'unit_100g'  },
  potatoes:    { name: 'Potatoes',           icon: '🥔', comparisonMode: 'unit_100g'  },
  potato:      { name: 'Potatoes',           icon: '🥔', comparisonMode: 'unit_100g'  },
  salad:       { name: 'Salad',              icon: '🥗' },
  herbs:       { name: 'Fresh Herbs',        icon: '🌿' },
  // Bread & Bakery
  bread:       { name: 'Bread',              icon: '🍞', comparisonMode: 'unit_100g'  },
  rolls:       { name: 'Rolls',              icon: '🥖', comparisonMode: 'unit_each'  },
  pastry:      { name: 'Pastry',             icon: '🥐' },
  // Cupboard
  beans:       { name: 'Beans & Pulses',     icon: '🫘', comparisonMode: 'unit_100g'  },
  tinned:      { name: 'Tinned Food',        icon: '🥫', comparisonMode: 'unit_100g'  },
  pasta_rice:  { name: 'Pasta & Rice',       icon: '🍝', comparisonMode: 'unit_100g'  },
  pasta:       { name: 'Pasta',              icon: '🍝', comparisonMode: 'unit_100g'  },
  noodles:     { name: 'Noodles',            icon: '🍜', comparisonMode: 'unit_100g'  },
  rice:        { name: 'Rice',               icon: '🍚', comparisonMode: 'unit_100g'  },
  cooking:     { name: 'Cooking Essentials', icon: '🧂' },
  oils:        { name: 'Oils',               icon: '🫒', comparisonMode: 'unit_100ml' },
  oil:         { name: 'Oils',               icon: '🫒', comparisonMode: 'unit_100ml' },
  cooking_oil: { name: 'Cooking Oil',        icon: '🫒', comparisonMode: 'unit_100ml' },
  flour:       { name: 'Flour',              icon: '🌾', comparisonMode: 'unit_100g'  },
  sugar:       { name: 'Sugar',              icon: '🍬', comparisonMode: 'unit_100g'  },
  spices:      { name: 'Spices',             icon: '🌶️' },
  cereals:     { name: 'Cereals',            icon: '🥣', comparisonMode: 'unit_100g'  },
  condiments:  { name: 'Condiments',         icon: '🍯' },
  sauces:      { name: 'Sauces',             icon: '🍅' },
  sauce:       { name: 'Sauce',              icon: '🍅' },
  jam:         { name: 'Jam & Spreads',      icon: '🍓' },
  spreads:     { name: 'Spreads',            icon: '🥜' },
  nuts:        { name: 'Nuts & Seeds',       icon: '🥜' },
  biscuits:    { name: 'Biscuits',           icon: '🍪' },
  chocolate:   { name: 'Chocolate',          icon: '🍫' },
  tea:         { name: 'Tea',                icon: '🍵' },
  coffee:      { name: 'Coffee',             icon: '☕' },
  juice:       { name: 'Juice',              icon: '🍊', comparisonMode: 'unit_100ml' },
  water:       { name: 'Water',              icon: '💧', comparisonMode: 'unit_100ml' },
};

// ── Get display config for any subcategory id ─────────────────────────────────
// Falls back gracefully for values not yet in the config.
export function getSubcategoryDisplay(subcategoryId) {
  if (!subcategoryId) return { name: 'Other', icon: '📦' };
  return SUBCATEGORY_CONFIG[subcategoryId] || {
    name: subcategoryId
      .split('_')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' '),
    icon: '📦',
  };
}
